<template>
  <div class="header">
    <div class="title" v-bind:class="mode == 'editor' ? 'editor-title' : ''">
      <div v-if="editor.title" class="ip-edit-title">
        <input :value="quiz.name" @input="changeQuiz(quiz, 'name', $event)" @change="changeQuiz(quiz, 'name', $event)" :ref='"edit_name_" + quiz.id' @focusout="setEditorTitle" />
      </div>
      <div v-else class="val-title">
        {{quiz.name}}
        <div v-if="mode=='editor'" class="edit-icon" @click="changeTitleQuiz(quiz.id)">
          <EditIcon />
        </div>
      </div>
    </div>
    <div class="description" v-bind:class="mode == 'editor' ? 'editor-des' : ''" >
      <div v-if="editor.description" class="ip-edit-description">
        <input :value="quiz.description" @input="changeQuiz(quiz, 'description', $event)" @change="changeQuiz(quiz, 'description', $event)" :ref='"edit_des_" + quiz.id' @focusout="setEditorDes" />
      </div>
      <div v-else class="val-des">
        {{quiz.description}}
        <div v-if="mode=='editor'" class="edit-icon" @click="changeDesQuiz(quiz.id)">
          <EditIcon />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditIcon from '../../ui/icons/svgs/icons/EditIcon'

export default {
  name: "Header",
  props: ['quiz', 'mode'],
  components: {
    EditIcon
  },
  data: function(){
    return {
      editor: {
        title: false,
        description: false
      }
    }
  },
  methods: {
    changeTitleQuiz(quiz_id){
      this.editor.title = true
      this.$nextTick(function () {
        this.$refs["edit_name_" + quiz_id].focus()
      })
    },
    changeDesQuiz(quiz_id){
       this.editor.description = true
       this.$nextTick(function () {
        this.$refs["edit_des_" + quiz_id].focus()
      })
    },
    setEditorTitle(){
      this.editor.title = false
    },
    setEditorDes(){
      this.editor.description = false
    },
    changeQuiz(quiz, file_name, $event){
      quiz.action('changeQuiz',file_name, $event.target.value);
    }
  }
};
</script>
<style lang="scss">
  .header{
    border-bottom: 1px dashed #DDDDDD;

    .title{
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        color: #333333;
    }

    .editor-title{
      .val-title{
        position: relative;
        .edit-icon{
          display: none;
        }
      }
      .val-title:hover{
        cursor: pointer;
        .edit-icon{
          display: block;
          position: absolute;
          top: 0;
          right: 0;
          width: 35px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 5px;
          background: #E4E4E4;
          svg{
            width: 16px;
            fill: #0C0C0C;
          }
        }
      }
      .ip-edit-title{
        display: flex;
        height: 35px;
        input{
          width: 100%;
          height: 100%;
          border-radius: 5px;
          border: 1px solid #ccc;
          padding: 0 10px;
          font-family: SFProDisplay, sans-serif;
          font-size: 16px;
          color: #333;
        }
      }
    }

    .description{
        font-size: 14px;
        line-height: 18px;
        color: #999999;
        margin: 5px 0 12px;
    }

    .editor-des{
      .val-des{
        position: relative;
        .edit-icon{
          display: none;
        }
      }
      .ip-edit-description{
        display: flex;
        height: 20px;
        input{
          width: 100%;
          height: 100%;
          border-radius: 5px;
          border: 1px solid #ccc;
          padding: 0 10px;
          font-family: SFProDisplay, sans-serif;
          font-size: 14px;
          color: #333;
        }
      }
    }
    .editor-des:hover{
      cursor: pointer;
      .val-des{
        .edit-icon{
          display: block;
          position: absolute;
          top: 0;
          right: 7.5px;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 5px;
          background: #E4E4E4;
          svg{
            width: 8px;
            fill: #ccc;
          }
        }
      }
    }
  }
</style>
